<template>
    <Modal v-model="editModal" title="变更回访状态" @on-cancel="cancel" :footer-hide="true" :mask-closable="false" width="800px">
        <Form :label-width="140" ref="formValidate" :model="formData" :rules="ruleValidate">
            <FormItem prop="revisitStatus" label="最新回访状态">
                <lzDicSelect v-model="formData.revisitStatus" dicType="VERIFY_STATUS" :transfer="true" clearable>
                </lzDicSelect>
            </FormItem>
            <FormItem prop="revisitDate" label="回访时间">
                <DatePicker v-model="formData.revisitDate" type="date" placeholder="请选择" :transfer="true" />
            </FormItem>
            <FormItem prop="remark" label="变更原因">
                <Input v-model="formData.remark" placeholder="请输入" clearable />
            </FormItem>
            <FormItem prop="link" label="回访链接">
                <Input v-model="formData.revisitUrl" placeholder="请输入" clearable />
            </FormItem>
        </Form>
        <div class="ivu-modal-footer">
            <Button type="text" @click="cancel">取消</Button>
            <Button type="primary" @click.stop="ok" v-preventReClick>确定</Button>
        </div>
    </Modal>
</template>

<script>
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
    components: {
        lzDicSelect
    },
    data() {
        return {
            editModal: false,
            formData: {},
            thisItem: {},
            ruleValidate: {
                revisitStatus: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
        }
    },
    methods: {
        open(item) {
            this.formData = {}
            this.thisItem = {}
            this.editModal = true
            this.handleReset('formValidate')
            this.thisItem = item
        },
        ok() {
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    this.$http({
                        url: '/buz/policyReceiptRecord/revisit/add',
                        type: "POST",
                        data: {
                            ...this.formData,
                            policyId: this.thisItem.id,
                            policyNo: this.thisItem.policyNo,
                        },
                        apiPermissionCode:'order_1_40_4'
                    }).then((res) => {
                        if (res.data) {
                            this.$notice.success('新增成功')
                            this.$emit('refresh');
                            this.editModal = false
                        }
                    })
                }
            });
        },
        cancel() {
            this.formData = {}
            this.thisItem = {}
            this.editModal = false
        },
        handleReset(name) {
            this.$refs[name].resetFields();
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-date-picker{
    width: 100%;
}
</style>